import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Features } from './pages/Features';
import { Roadmap } from './pages/Roadmap';
import { Docs } from './pages/Docs';
import { Versions } from './pages/Versions';
import { Download } from './pages/Download';
import { Sponsor } from './pages/Sponsor';
import { GuidePage } from './pages/GuidePage';
import { SdkPage } from './pages/SdkPage';
import { Tools } from './pages/Tools';
import { NotFound } from './pages/NotFound';

export function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="features" element={<Features />} />
        <Route path="roadmap" element={<Roadmap />} />
        <Route path="docs" element={<Docs />} />
        <Route path="versions" element={<Versions />} />
        <Route path="tools" element={<Tools />} />
        <Route path="download" element={<Download />} />
        <Route path="sponsor" element={<Sponsor />} />
        <Route path="guide" element={<Navigate to="/guide/overview" replace />} />
        <Route path="guide/:slug" element={<GuidePage />} />
        <Route path="sdk" element={<Navigate to="/sdk/guide-overview" replace />} />
        <Route path="sdk/:slug" element={<SdkPage />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
